export var selectTooltipState = state => state.tooltip;